

































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Kesadaran extends Vue {
  @Prop() setKesadaran!: string;
  @Prop() setLabel!: string;
  // kesadaran = "";
  label = "";
  placeholder = this.setLabel;

  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (this.setKesadaran == "" || this.setKesadaran == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }

  // @Watch("kesadaran")
  // changeKesadaran(val) {
  //   if (this.setLabel == "") {
  //     this.label = "";
  //     this.placeholder = "";
  //   } else {
  //     if (val == "" || val == null) {
  //       this.label = "";
  //       this.placeholder = this.setLabel;
  //     } else {
  //       this.label = this.setLabel;
  //       this.placeholder = "";
  //     }
  //   }
  //   this.$emit("kesadaran", val);
  // }

  @Watch("setKesadaran")
  valkesadarann(val) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (val == "" || val == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("kesadaran", val);
    this.setKesadaran = val;
  }
}
